import React from "react";
import Ingredient from "../Ingredient";
import raw from "../../assets/images/ingredients/Raw_steak.png";
import cooked from "../../assets/images/ingredients/Cooked_Steak.png";

const Steak = ({ onClick, changeable=true, changed, hideable=true }) => {
    return (
        <Ingredient
            name="Steak"
            image={[raw, cooked]}
            changeable={changeable}
            changed={changed}
            hideable={hideable}
            onClick={onClick}
        />
    );
};

export default Steak;